<template>
  <div class="flex flex-wrap items-center gap-1" data-testid="professional-tags">
    <LabelBadge
      v-for="tag in ordered"
      :key="tag"
      :label="REVIEW_TAG_CONFIG[tag].label"
      :color="REVIEW_TAG_CONFIG[tag].color"
      :icon="REVIEW_TAG_CONFIG[tag].icon"
      size="small"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import type { ReviewQueueTag } from '@/types/professional-documents.types'

import { REVIEW_TAG_CONFIG, REVIEW_TAG_ORDER } from '../constants'

const props = defineProps<{ tags: ReviewQueueTag[] }>()

/** Ordem fixa (Novo → Urgente → Bloqueia alocação → Concluído), independente da do backend. */
const ordered = computed(() => REVIEW_TAG_ORDER.filter((tag) => props.tags.includes(tag)))
</script>
